/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Issue_Too_Many_Rows_BsInputs */

const en_statement_taxonomy_issue_too_many_rows_bs = /** @type {(inputs: Statement_Taxonomy_Issue_Too_Many_Rows_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many balance-sheet rows`)
};

const nl_statement_taxonomy_issue_too_many_rows_bs = /** @type {(inputs: Statement_Taxonomy_Issue_Too_Many_Rows_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te veel balansregels`)
};

/**
* | output |
* | --- |
* | "Too many balance-sheet rows" |
*
* @param {Statement_Taxonomy_Issue_Too_Many_Rows_BsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_issue_too_many_rows_bs = /** @type {((inputs?: Statement_Taxonomy_Issue_Too_Many_Rows_BsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Issue_Too_Many_Rows_BsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_issue_too_many_rows_bs(inputs)
	return en_statement_taxonomy_issue_too_many_rows_bs(inputs)
});